import Code from "@mui/icons-material/Code";
import TableChart from "@mui/icons-material/TableChart";
import TableView from "@mui/icons-material/TableView";
import Upload from "@mui/icons-material/Upload";
import Button from "@mui/material/Button";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import React, { useState } from "react";
import { useExportProcessings } from "./OrionQueries";

function ExportMenu({
  assetIds,
  disabled = false,
}: {
  assetIds: string[];
  disabled?: boolean;
}) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { mutate: downloadFile } = useExportProcessings();
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const exportOptions = [
    { format: "csv", label: "CSV", icon: <TableChart /> },
    { format: "json", label: "JSON", icon: <Code /> },
    { format: "csv_for_excel", label: "CSV pour Excel", icon: <TableView /> },
    // { format: "xlsx", label: "Excel", icon: <ExcelIcon /> },
  ] as const;

  return (
    <>
      <Button
        variant="contained"
        size="small"
        startIcon={<Upload />}
        onClick={handleClick}
        disabled={disabled}
      >
        Export
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {exportOptions.map(({ format, label, icon }) => (
          <MenuItem
            key={format}
            onClick={() => downloadFile({ assetIds, format })}
          >
            <ListItemIcon>{icon}</ListItemIcon>
            <ListItemText>{label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

export default ExportMenu;
